@if (isManual || breadcrumbs.length > 0) {
<div class="cs-nav-wrapper">
  <div class="cs-nav-bar">
    @if(breadcrumbs.length) {
    <ol class="cs-nav-links">
      @for (breadcrumb of breadcrumbs; track $index; let i=$index; let last = $last) {
      @if (!last && breadcrumb.url !== '') {
      <li>
        @if (isManual) {
        <a [attr.href]="breadcrumb.url" (click)="onNavigate($event, breadcrumb)" [translate]="breadcrumb.label"></a>
        } @else {
        <a [routerLink]="breadcrumb.url" [translate]="breadcrumb.label"></a>
        }
      </li>
      } @else {
      <li><span [translate]="breadcrumb.label"></span></li>
      }
      }
    </ol>
    } @else {
    <div class="cs-breadcrumb-skeleton">
      <div class="loading-row animated-background" style="width: 60px; height: 12px;"></div>
      <span>/</span>
      <div class="loading-row animated-background" style="width: 100px; height: 12px;"></div>
      <span>/</span>
      <div class="loading-row animated-background" style="width: 140px; height: 12px;"></div>
    </div>
    }
  </div>
</div>
}